import { resolveCname } from 'dns';
import { parse as parseURL } from 'url';

import BaseService from '../../shared/services';

class DnsService extends BaseService {
  public cnameLookup = (endpoint: string) => {
    const url = parseURL(endpoint);
    const hostname = (url.protocol ? url.hostname : url.href) || '';

    return this.tryExecute<string[]>(
      () =>
        new Promise((resolve, reject) => {
          resolveCname(hostname, (error, addresses) => {
            if (error) {
              reject(new Error(error.message));
              return;
            }
            resolve(this.serviceResponse(addresses));
          });
        })
    );
  };
}

export default DnsService;
